import React from 'react'
import { TypeItemLinkableBox } from '../../../lib/types/item-linkable-box'
import { EntryContentProps } from '../../renderer'
import { isTypeItemEventOrArticle, isTypeItemTestimonial } from '../../../lib/types/content-types'
import { EventOrArticle } from '../event-or-article'
import { TestimonialItem } from '../../section/testimonial/item'

export const LinkableBoxItem: React.FC<EntryContentProps<TypeItemLinkableBox>> = ({ structure }) => {
  const {
    fields: { content, size, link },
  } = structure

  if (isTypeItemEventOrArticle(content)) {
    return <EventOrArticle structure={content} link={link} size={size} />
  }

  if (isTypeItemTestimonial(content)) {
    return <TestimonialItem structure={content} link={link} />
  }

  return null
}
